import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

const redirectUrlSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_layout/')({
  component: LandingPage,
  validateSearch: search => redirectUrlSchema.parse(search),
});

function LandingPage() {
  return (
    <div className="from-primary-light-three via-background to-tertiary-light-three bg-lineat-to-br relative flex min-h-dvh items-center justify-center overflow-hidden px-6 py-12">
      <div
        aria-hidden
        className="bg-primary/30 motion-safe:animate-float pointer-events-none absolute -top-32 -left-32 size-96 rounded-full opacity-40 blur-3xl"
      />
      <div
        aria-hidden
        className="bg-tertiary/30 motion-safe:animate-float pointer-events-none absolute -right-32 -bottom-32 size-96 rounded-full opacity-40 blur-3xl"
      />

      <section className="bg-card/70 border-border/60 relative z-10 flex w-full max-w-xl flex-col items-center gap-8 rounded-2xl border p-8 text-center shadow-2xl backdrop-blur-2xl sm:p-12">
        <div className="bg-primary/10 ring-primary/20 flex size-20 items-center justify-center rounded-full ring-1 motion-safe:animate-pulse">
          <img alt="Fixxer" className="size-12" src="/logo380.png" />
        </div>

        <span className="bg-primary/10 text-primary border-primary/20 inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium tracking-wide uppercase">
          <span className="bg-primary size-1.5 animate-pulse rounded-full" />
          Launching soon
        </span>

        <div className="flex flex-col gap-3">
          <h1 className="text-foreground text-4xl font-bold tracking-tight sm:text-5xl">
            Welcome
          </h1>
          <p className="text-muted-foreground text-lg sm:text-xl">
            We&rsquo;re getting things ready.
          </p>
          <p className="text-foreground/70 mx-auto max-w-prose text-sm sm:text-base">
            Fixxer Coordinate is launching soon &mdash; a faster way to manage
            claims, interventions, and field teams in one place.
          </p>
        </div>

        <p className="text-muted-foreground text-xs">
          &copy; {new Date().getFullYear()} Fixxer &middot; All rights reserved
        </p>
      </section>
    </div>
  );
}
